
























import { EstimatedType } from '@tt4b/ttam-enums';
import { convertRtlStyle } from '@tt4b/ttam-utils';
import { defineComponent, computed, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';

const name = 'ttam-audience-size-estimate-chart';
export default defineComponent({
  props: {
    estimateType: {
      type: Number as PropType<EstimatedType>,
    },
  },
  setup(props) {
    const { estimateType } = toRefs(props);
    const progressStyle = computed(() => {
      const ProcessColor = ['#fe0251', '#b850bf', '#b850bf', '#346cf5', '#16e8ed'];
      const processColorArr = ProcessColor.slice(0, estimateType.value + 1);

      if (estimateType.value === EstimatedType.NONE) {
        return {
          width: '5px',
          progressBackColor: '#fff',
        };
      }

      return {
        width: estimateType.value ? `${estimateType.value + estimateType.value}0%` : '5px',
        pointColor: processColorArr[processColorArr.length - 1],
        bgColor:
          processColorArr.length > 1 ? `linear-gradient(to right, ${processColorArr.join(',')})` : processColorArr[0],
      };
    });
    const pointStyle = computed(() =>
      convertRtlStyle({
        background: progressStyle.value.pointColor,
        left: progressStyle.value.width,
      })
    );
    return {
      name,
      progressStyle,
      pointStyle,
    };
  },
});
